<template>
  <div class="user-play por">
    <template v-if="listLength">
      <template v-for="(row, i) in list">
        <div :key="i" class="row" v-if="row.list.length">
          <div class="user-df-title lh1">{{row.name}}</div>
          <div class="list flex fww">
            <course-card :item="course" class="course"
                         img-key="course_bigimg"
                         image-width="202"
                         hidden-audio
                         @detail="courseClick"
                         width="202"
                         image-height="114"
                         show-props="course_name,resources_name"
												 filter="course_name"
                         v-for="(course, j) in row.list" :key="j">
              <template #image="{item}">
                <div class="course-image-box">
                  <i class="mine-ico poa audio img" v-show="item.format_id === 2 && item.type === 1"></i>
                  <div class="hover-box poa dn w100 h100 t0 l0 zi1" :class="{'hover-show': !isEdit}" @click.stop>
                    <i class="hover-to-play abs-mc mine-ico hover-play csp" @click="courseClick(item)"></i>
                    <i class="hover-del-one poa mine-ico hover-delete img csp"
                       @click="delCourse(item.resource_id, i, j)"></i>
                  </div>
                  <div class="edit-checkbox zi1 poa t0 l0 r0" v-show="isEdit">
                    <i class="mine-ico abs-m"
                       :class="selected.includes(item.resource_id) ? 'checkbox-check' : 'checkbox-df'"></i>
                  </div>
                </div>
              </template>
            </course-card>
          </div>
        </div>
      </template>
      <mine-edit v-model="isEdit"
                 :selected="selected.length"
                 @edit-callback="editCb"
                 class="edit"></mine-edit>
      <df-page :total="total" :page-size="limits" :current="curr" @change="changePage"></df-page>
    </template>
    <template v-else-if="total === null">
      <!-- no list -->
      <mine-no-data></mine-no-data>
    </template>
  </div>
</template>

<script>
  import {mapGetters,mapMutations} from 'vuex';
  import Mixins from '../../mixins/mixins';
  import MineEdit from '../../components/mine/edit';

  export default {
    name: "UserPlay",
    components: {
      MineEdit,
    },
    // mixins: [Mixins.AppScroll()],
    // appScroll(e) {
    //   let {height} = e.target.getBoundingClientRect();
    //   let {bottom} = this.$el.getBoundingClientRect();
    //   if (bottom - height / 3 < height && !this.isAllLoad && !this.loading) {
    //     this.curr++;
    //     this.getList();
    //   }
    // },
    computed: {
      ...mapGetters(['userInfo']),
      isAllLoad() {
        return this.listLength >= this.total && this.total;
      },
      listLength() {
        return this.today.length + this.week.length + this.more.length;
      },
      list() {
        return [
          {name: '今天', type: 1, list: this.today},
          {name: '一周内', type: 7, list: this.week},
          {name: '更早', type: 0, list: this.more},
        ];
      },
    },
    data() {
      return {
        today: [],
        week: [],
        more: [],
        isMore: false,
        isEdit: false,

        isLoading: false,

        weekStr: [],
        currStr: '',
        timeStr: 'Y-M-D',

        selected: [],

        curr: 1,
        limits: 20,
        total: 0,

        isClick: false,
      };
    },
    created() {
      this.currStr = this.Tools.formatDate(new Date(), this.timeStr);
      for (let i = 6; i > 0; i--) {
        this.weekStr.push(this.Tools.typeToDate(i).map(e => this.Tools.formatDate(e, this.timeStr))[0]);
      }
      this.getList(1);
    },
    methods: {
			...mapMutations(['setRefreshHistory']),
      changePage(val, prop){
        if(this.curr === val) return;
        this.curr = val;
        this.getList();
      },
      editCb(type) {
        switch (type) {
          case 'all':
            this.selected = [...this.today, ...this.week, ...this.more].map(e => e.resource_id);
            break;
          case 'del':
            this.delCourse();
            break;
          case 'cancel':
            this.selected = [];
            this.isEdit = false;
            break;
        }
      },
      courseClick(item) {
        if (this.isEdit) {
          if (this.selected.includes(item.resource_id)) {
            this.selected = this.selected.filter(id => id !== item.resource_id);
          } else {
            this.selected.push(item.resource_id);
          }
        } else {
          this.OpenRouter({
            path: (item.format_id === 2 ? '/home/audio/details/' : '/home/video/details/') + item.course_id + '/' + item.is_free,
            query: {
              rid: item.resource_id,
            }
          });
        }
      },
      delCourse(id, i, j) {
        if(this.isClick){
          return;
        }
        this.isClick = true;
        if (id || this.selected.length) {
          let params = {
            uid: this.userInfo.uid,
            ...this.Product,
            resource_id: (id ? [id] : this.selected) + '',
            type: 'del_course',
          };
          this.http.del(params,{ needCancel: 'url' }).then(res => {
            this.ShowToast('删除成功！');
						// 改变浏览记录的刷新状态，同步头部
						this.setRefreshHistory(true)
            this.selected = [];
            if (id) {
              let list = this[['today', 'week', 'more'][i]];
              list.splice(j, 1);
              this.getList('isDel', this.listLength + 1);
            } else {
              this.getList(1);
            }
          }).catch(()=>{this.getList(1); this.$err}).finally(()=>{ this.isClick = false;});
        }
      },
      getList(init, curr) {
        if(!this.userInfo.uid) return;
        if (this.loading) return;
        this.loading = true;
        if (init !== 'isDel' && init) {
          this.curr = 1;
          this.isMore = false;
        }
				// console.log({
    //       uid: this.userInfo.uid,
    //       curr: this.curr,
    //       limits: this.limits,
    //       ...this.Product,
    //     })
        this.http.NEWList({
          uid: this.userInfo.uid,
          curr: this.curr,
          limits: this.limits,
          ...this.Product,
        }).then(res => {
					this.total = res.total || null;
					// 还原浏览记录的刷新状态
					this.setRefreshHistory(false);
					//第二页后并且删除到当前curr页面的数据为空时，获取上一页数据
					if(this.total &&this.curr>1 && this.total===((this.curr-1)*this.limits) ){
						this.loading = false;
						this.curr--;
						this.getList();
						return
					}
          // if (this.curr === 1 && !curr) {
            this.today = [];
            this.week = [];
            this.more = [];
          // }
          // if (this.isMore) {
          //   this.more.push(...res.list);
          // } else {
            res.list.map(e => {
              let curr = this.Tools.formatDate(e.time, this.timeStr);
              if (curr === this.currStr) {
                this.today.push(e);
              } else if (this.weekStr.includes(curr)) {
                this.week.push(e);
              } else {
                this.isMore = true;
                this.more.push(e);
              }
            });
          // }
        }).catch(this.$err).finally(() => {
          this.loading = false;
        });
      },
    },
  }
</script>

<style scoped lang="less">

  .course-image-box {
    .audio {
      left: 8px;
      bottom: 5px;
    }
    .hover-box {
      cursor: unset;
      background-color: rgba(0, 15, 34, .5);
    }
    .hover-delete {
      top: 6px;
      right: 8px;
    }
    .edit-checkbox {
      height: 32px;
      line-height: 0;
      background: linear-gradient(180deg, rgba(0, 15, 34, 0.5), rgba(0, 15, 34, 0));
      .mine-ico {
        right: 8px;
      }
    }
  }

  .user-play {
    padding: 16px 18px;
  }

  .list {
    margin-left: -16px;
  }

  .title {
    margin-bottom: 24px;
    padding: 16px 0 0 14px;
    font-size: 26px;
    color: #333f4e;
  }

  .course-card {
    margin: 0 0 24px 16px;
    align-items: unset;
    &:hover {
      /deep/ .course_name {
        color: #1177ff;
      }
      /deep/ .resources_name {
        color: #999fa6;
      }
    }
    /deep/ .course_name {
      font-size: 16px;
      color: #333f4e;
      &:hover {
        color: #1177ff;
      }
    }
    /deep/ .resources_name {
      padding-top: 10px;
      font-size: 14px;
      color: #999fa6;
    }
    /deep/ .detail-box {
      padding: 0;
    }
    /deep/ .vip-type-tip {
      display: none;
    }
  }
</style>